import {
  ISectionHorizontalItemTextListProps,
} from "../SectionHorizontalIconTextList";

export const sectionHorizontalItemTextListData: ISectionHorizontalItemTextListProps = {
  title: "Take A 14-day TRIAL - here's what we promise",
  subtitle: "From less than £2 a day, here's what you'll get:",
  image: {
    src: "/images/landingPage/trial/free-gifts.webp",
    width: 686,
    height: 686,
  },
  ctas: [
    {
      children: "Get 20% off your trial box",
      to: "/forms/fresh-food-new-user?discount_code=TRY20",
    },
  ],
  list: {
    listTag: "ul",
    items: [
      {
        icon: "padlockUnlocked",
        title: "Manage your deliveries\nwith complete flexibility",
        body: "Change your mix of recipes easily, or cancel altogether - and no surprise charges, ever.",
        spans: { lg: 6 },
      },
      {
        icon: "phone",
        title: "Customer love guaranteed",
        body: <>Get answers, advice and even speak to a vet.
          Call us 7 days a week on <a href="tel:02045384144">0204 538 4144</a> or
          email <a href="mailto:meow@katkin.com">meow@katkin.com</a></>,
        spans: { lg: 6 },
      },
    ],
  },
  theme: "light",
};
